import { Component, OnInit, HostBinding, HostListener } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, LayoutActionTypes } from '@app/core/ngrx';
import { MsalService } from '@azure/msal-angular';

/**
 * HeaderComponent
 */
@Component({
  selector: 'ecp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @HostBinding('class.header') header = true;
  @HostBinding('class.shrink') shrink = false;
  /**
   * breakpoint
   * @type {string}
   */
  private breakpoint = '(max-width: 899px)';
  /**
   * sideNav$
   */
  // @select(['layout', 'sidenav'])
  sideNav$: Observable<any>;
  /**
   * authenticated$
   */
  // @select(['auth', 'authenticated'])
  authenticated$: Observable<any>;

  /**
   * constructor
   * @param {BreakpointObserver} breakpointObserver
   * @param {Store<AppState>} store
   */
  constructor(
    private breakpointObserver: BreakpointObserver,
    private store: Store<AppState>,
    private msalService: MsalService,
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.sideNav$ = this.store.pipe(select((state) => state.layout.sidenav));
    this.authenticated$ = this.store.pipe(select((state) => state.auth.authenticated));
    this.initBreakpointObserver();
  }

  /**
   * initBreakpointObserver
   */
  initBreakpointObserver(): void {
    this.breakpointObserver.observe([this.breakpoint]).subscribe((state: BreakpointState) => {
      if (!state.matches) {
        this.store.dispatch({ type: LayoutActionTypes.CLOSE_SIDENAV });
      }
    });
  }

  logout(): void {
    this.msalService.logout();
  }

  /**
   * onPageScroll
   */
  @HostListener('window:scroll', ['$event'])
  onPageScroll(): void {
    this.shrink = document.documentElement.scrollTop >= 70;
  }
}
